// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HowToBecome_wrapper__0yOus","index":"HowToBecome_index__AFVLk","title":"HowToBecome_title__3yiOz"};